// @vendors
import React from 'react';

// @commponents
import AggregatorAddEntityLayout from 'components/aggregator/aggregatorAddEntity/aggregatorAddEntityLayout/aggregatorAddEntityLayout'
import AggregatorAcceptConsent from 'components/aggregator/aggregatorAcceptConsent/aggregatorAcceptConsent';
const { formatText } = require('core/i18n').i18n;

class AggregatorAcceptConsentView extends React.PureComponent {

    render() {
        return (
            <AggregatorAddEntityLayout title={formatText('aggregatorPSD2-consentHeaderTitle')}>
                <AggregatorAcceptConsent {...this.props}/>
            </AggregatorAddEntityLayout>  
        )
    }
}

module.exports.constructor = AggregatorAcceptConsentView;
module.exports.AggregatorAcceptConsentView = AggregatorAcceptConsentView